import { css } from '@emotion/css'
import { spacing, shorthandHelper, colors } from '@offerzen/pinata'

const styles = {
  box: css({
    height: 40,
    marginBottom: spacing.small,
  }),

  tags: css({
    marginTop: spacing.default,

    '& > * + *': {
      marginLeft: spacing.small,
    },
  }),

  footer: css({
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${colors.mystic}`,
    margin: shorthandHelper([spacing.medium, -spacing.large, -spacing.small, -spacing.large]),
    padding: shorthandHelper([spacing.medium, spacing.large, 0, spacing.large]),
  }),
}

export default styles
